import { IAction } from '@r1-frontend/shared/types/Redux';

import { BP42Action } from '~/src/packages/bp42/constants/actions';
import { BP42IncomingData } from '~/src/packages/bp42/reducer/initialState';

const initialization = (incomingData: Partial<BP42IncomingData>): IAction<BP42Action.Initialization, Partial<BP42IncomingData>> => ({
    type: BP42Action.Initialization,
    payload: {
        ...incomingData,
    },
});

export default initialization;
